var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"movie-swiper component"},[_c('swiper',{ref:"movieSwiper",staticClass:"swiper",attrs:{"options":_vm.swiperOption},on:{"swiper":_vm.onSwiper,"slideChange":_vm.onSlideChange}},_vm._l((_vm.movies),function(movie,idx){return _c('swiper-slide',{key:idx},[_c('img',{attrs:{"src":_vm.getProxyImageUrl(movie.image)}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }